import React from 'react';
import nav from '../css/navbar.module.css';
import logo from '../assets/logo.svg';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import { Link } from 'react-router-dom';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useSelector } from 'react-redux';
import { getTotalAmountInCart } from '../selectors';
const NavBar = ({ match }) => {
    const amountInCart = useSelector((state) => getTotalAmountInCart(state));
    return (
        <div>
            <AppBar className={nav.bg}>
                <Link to="/liquors" className={nav.logo_container}>
                    <img
                        className={nav.logo}
                        src={logo}
                        alt="windsor liquors logo"
                    />
                </Link>
                {match.path !== '/cart' ? (
                    <Link to="/cart">
                        <IconButton
                            aria-label="Shopping Cart"
                            style={{ marginRight: '.4em' }}
                        >
                            <ShoppingCartIcon
                                style={{
                                    fontSize: '1.5em',
                                    color: '#2a2d35',
                                }}
                            />
                            {!!amountInCart && (
                                <div className={nav.amount}>{amountInCart}</div>
                            )}
                        </IconButton>
                    </Link>
                ) : (
                    <Link to="/profile">
                        <IconButton style={{ marginRight: '.4em' }}>
                            <AccountCircleIcon
                                fontSize="large"
                                style={{ color: '#2a2d35' }}
                            />
                        </IconButton>
                    </Link>
                )}
            </AppBar>
            <div style={{ height: '5em' }}></div>
        </div>
    );
};

export default NavBar;
